import { objectWithoutProperties as _objectWithoutProperties, toConsumableArray as _toConsumableArray, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { getTvObject } from '@costar-ui/cosmos';
import { focusRing } from '../../theme/styles/common.esm.js';
import radiusOptions from '../radius-options/radius-options.esm.js';
import flexOptions from '../flex-options/flex-options.esm.js';

// support only horizontal flex no reason to support vertical orientation in a field compositions
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var _flexOptions$variants = flexOptions.variants;
  _flexOptions$variants.direction;
  _flexOptions$variants.scrollable;
  var flexOptionsVariants = _objectWithoutProperties(_flexOptions$variants, ["direction", "scrollable"]);

// this option is intended to be apply to an input wrapper like FieldGroup where there are composition
// of elements that include an input element with other element. It can also be apply directly to and input element
// by it self.
var fieldOptions = getTvObject({
  base: [].concat(_toConsumableArray(focusRing.base), ['outline-0', 'border', 'border-action-neutral', 'group', 'relative', 'flex', 'items-center', 'hover:border-hover', 'overflow-hidden', 'forced-colors:bg-[Field]']),
  variants: _objectSpread2(_objectSpread2({
    size: {
      std: 'h-8 text-p-16',
      sm: 'h-6 text-p-14',
      xxs: 'h-4 text-p-12'
    },
    radius: radiusOptions.radius
  }, flexOptionsVariants), {}, {
    canShrink: {
      "true": ['min-w-0', 'shrink', 'grow']
    },
    isFocusWithin: {
      "true": 'border-focus outline-0'
    },
    isInvalid: {
      "true": 'border-status-negative outline-0 hover:border-status-negative'
    },
    isDisabled: {
      "true": 'cursor-not-allowed border-disabled bg-action-disabled text-action-disabled hover:border-disabled'
    }
  })
});
var fieldOptions$1 = fieldOptions;

export { fieldOptions$1 as default };
//# sourceMappingURL=field-options.esm.js.map
